import axios from 'axios';
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
  CloseOutlined,
  CheckCircleOutlined,
  DragOutlined
} from '@ant-design/icons';

export default {
  getAnnouncements: async function (setFuncMap) {
    try {
      const res = await this.getAnnouncementsAction()
      setFuncMap.setAnnouncements(res.data)
      setFuncMap.setIsPageLoading(false)
    } catch (error) {
    }
  },
  getAnnouncementsAction: () => {
    return axios({
      method: 'GET',
      url: `/site/announcements`
    })
  }
};
